import React, { useEffect, useState } from 'react';
import { MetaTags } from 'react-meta-tags';
import { useLocation, useHistory } from 'react-router-dom';
//import Breadcrumbs
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import 'react-drawer/lib/react-drawer.css';
import { Col, Container, Row, Spinner } from 'reactstrap';
import { Toaster } from 'react-hot-toast';
import ManageServiceOrdersList from './components/ManageServiceOrdersList';
import CreateServiceOrderOffcanvas from './components/CreateServiceOrderOffcanvas';
import SearchOrderOffcanvas from './components/SearchOrderOffcanvas';
import ServiceOrderExportReport from './components/ServiceOrderExportReport';
import { EXPORT_ALLOWED_USER_ROLES } from '../../../constants/index';

const ManageServiceOrders = () => {
  const users = JSON.parse(localStorage?.getItem('authUser'));
  const location = useLocation();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState();
  const [showCreateServiceOrder, setShowCreateServiceOrder] = useState(false);
  const [showSearchOrder, setShowSearchOrder] = useState(false);
  const [selectedOrderData, setSelectedOrderData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [viewType, setViewType] = useState('list');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('openCreate') === '1') {
      let prefill = null;
      try {
        const raw = localStorage.getItem('__prefillCreateServiceOrder');
        if (raw) {
          prefill = JSON.parse(raw);
          localStorage.removeItem('__prefillCreateServiceOrder');
        }
      } catch (e) {
        // ignore parse/storage errors and proceed without prefill
      }
      if (prefill) {
        setSelectedOrderData(prefill);
        setShowCreateServiceOrder(true);
      }
      params.delete('openCreate');
      history.replace({ pathname: location.pathname, search: params.toString() });
    }
  }, []);
  
  const toggleSearchOrder = () => setShowSearchOrder((prev) => !prev);
  const toggleCreateServiceOrder = () =>
    setShowCreateServiceOrder((prev) => !prev);
  
  const handleOrderSelect = (orderData) => {
    setSelectedOrderData(orderData);
    setShowCreateServiceOrder(true);
  };
  
  const handleServiceOrderCreated = () => {
    setRefreshList((prev) => !prev);
    setSelectedOrderData(null);
  };

  return (
    <React.Fragment>
      {loading ? (
        <div className="loader-container">
          <Spinner type="grow" className="ms-2" color="dark" />
        </div>
      ) : (
        <></>
      )}
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Manage Service Orders</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row className="align-items-center">
            <Col xl={4}>
              <DashBreadcrumb
                title="Service Orders"
                breadcrumbItem="Manage Service Orders List"
              />
            </Col>
            <Col xl={8}>
              <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
                <div className="DashbordFliter">
                  <button
                    type="button"
                    className="btn btn-dark"
                    onClick={toggleSearchOrder}
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    Create Service Order
                  </button>
                </div>
                {EXPORT_ALLOWED_USER_ROLES.includes(String(users?.role_id)) && (
                  <div>
                    <ServiceOrderExportReport />
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <ManageServiceOrdersList
            stores={stores}
            refreshList={refreshList}
            viewType={viewType}
            headerActions={
              <div
                className="btn-group shadow-sm"
                role="group"
                aria-label="View toggle"
              >
                <button
                  type="button"
                  className={`btn d-inline-flex align-items-center gap-1 ${
                    viewType === 'list'
                      ? 'btn-dark'
                      : 'btn-outline-dark bg-white'
                  }`}
                  onClick={() => setViewType('list')}
                >
                  <i className="mdi mdi-format-list-bulleted"></i>
                  List View
                </button>
                <button
                  type="button"
                  className={`btn d-inline-flex align-items-center gap-1 ${
                    viewType === 'map'
                      ? 'btn-dark'
                      : 'btn-outline-dark bg-white'
                  }`}
                  onClick={() => setViewType('map')}
                >
                  <i className="mdi mdi-map-marker-radius-outline"></i>
                  Map View
                </button>
              </div>
            }
          />
          <SearchOrderOffcanvas
            isOpen={showSearchOrder}
            toggle={toggleSearchOrder}
            onOrderSelect={handleOrderSelect}
          />
          <CreateServiceOrderOffcanvas
            isOpen={showCreateServiceOrder}
            toggle={toggleCreateServiceOrder}
            users={users}
            selectedOrderData={selectedOrderData}
            onServiceOrderCreated={handleServiceOrderCreated}
          />
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default ManageServiceOrders;
